// Auto generated from Stimson
// Commit ID: 980a120e0218b55828a6417af75f1f2b27dc603d
export type DynamoOptional = undefined | null;
export interface DomainMemberDetails {
  Title: MemberDetailsTitle | undefined | null;
  FirstName: string | undefined | null;
  LastName: string | undefined | null;
  Email: string | undefined | null;
  Address1: string | undefined | null;
  Address2: string | undefined | null;
  City: string | undefined | null;
  StateProvince: string | undefined | null;
  PostalCode: string | undefined | null;
  Country: string | undefined | null;
  CountryIsoCode: string | undefined | null;
  Telephone: PhoneNumber | undefined | null;
  EjPlusNumber: string | undefined | null;
  MemberId: string | undefined | null;
  HasBeenUpdated: boolean;
  IsNewUser: boolean;
  KeepMeSignedIn: boolean;
  KeepMeSignedInMinutes: number;
  OptInForEasyJetMailing: boolean | undefined | null;
  OptInForMailing: boolean | undefined | null;
  SavedCardDetails: DomainMemberCardDetails | undefined | null;
}

export enum MemberDetailsTitle {
  Mr = 0,
  Mrs = 1,
  Ms = 2,
  Miss = 3
}

export interface PhoneNumber {
  FullPhoneNumber: string | undefined | null;
  // DialingCode: string | undefined | null; //This is not included in the serialised basket
  // PhoneNumberWithoutDialingCode: string | undefined | null; //This is not included in the serialised basket
}

export interface DomainMemberCardDetails {
  CardNumberLastFourDigits: string | undefined | null;
  NameOnCard: string | undefined | null;
  CardVendorCode: string | undefined | null;
  ExpiryMonth: number;
  ExpiryYear: number;
}

export interface Passenger {
  InternalId: string;
  Title: PassengerTitle | undefined | null;
  FirstName: string | undefined | null;
  LastName: string | undefined | null;
  Type: PassengerType;
}

export interface FunnelPassenger extends Passenger {
  Age: number | undefined | null;
  EjPlusNumber: string | undefined | null;
  NifNumber: string | undefined | null;
  SpecialServiceRequestCodes: string[] | undefined | null;
}

export enum PassengerTitle {
  Mr = 0,
  Mrs = 1,
  Ms = 2,
  Miss = 3,
  Infant = 4,
  Object = 5
}

export enum PassengerType {
  Adult = 0,
  Child = 1,
  Infant = 2,
  Object = 3
}

export interface FlightAssociation {
  FlightInternalId: string;
  PassengerInternalId: string;
  CarriedInfantInternalId: string | undefined | null;
  Vouchers: FlightAssociationVouchers | undefined | null;
  CheckedIn: boolean;
}

export interface FlightAssociationVouchers {
  Quantity: number;
  Cost: number;
  CostCreditCardFee: number;
  RedeemableAmount: number;
}

export interface CarriedInfant extends Passenger {
  Age: number | undefined | null;
}

export interface JourneyPair {
  Id: number;
  IsPrimaryPair: boolean;
  BaseCurrency: string | undefined | null;
  OutboundSlot: JourneySlot | undefined | null;
  ReturnSlot: JourneySlot | undefined | null;
}

export interface JourneySlot {
  Flight: FunnelFlight | null;
}

export interface BasicFlight {
  InternalId: string;
  FlightNumber: FlightNumber | undefined | null;
  DepartureIata: string | undefined | null;
  ArrivalIata: string | undefined | null;
  DepTerminalName: string | undefined | null;
  ArrTerminalName: string | undefined | null;
  // Manual fix
  LocalDepartureTime: string;
  LocalArrivalTime: string;
}

export interface FunnelFlight extends BasicFlight {
  FlightFares: FlightFare[] | undefined | null;
  FlightTaxes: FlightTaxesData | undefined | null;
}

export interface BasicFlightFare {
  FareType: FareType;
  Prices: FlightPrices | undefined | null;
  FlightIdentification: string | undefined | null;
  DiscountAmounts?: FlightDiscountAmount;
}

export interface FlightFare extends BasicFlightFare {
  SeatsAvailable: number;
  LowestFareSeatsAvailable: number | undefined | null;
}

export enum FareType {
  Standard = 0
}

export interface FlightPrices {
  Adult: Price | undefined | null;
  Child: Price | undefined | null;
  Infant: Price | undefined | null;
}

export interface FlightDiscountAmount {
  Adult?: number;
  Child?: number;
}

export interface Price {
  Value: number;
  ValueWithDebitCard: number;
  ValueWithCreditCard: number;
}

export interface FlightTaxesData {
  TaxAmount: number;
  ApplyApdRules: boolean;
}
// type FlightNumber = string;
// FlightNumber is included in the serialised basket as a string with the CarrierCode and Number properties concatanated together (i.e. 'CarrierCode'+'Number') without any additional properties
export interface FlightNumber {
  CarrierCode: string | undefined | null; //This is not included in the serialised basket
  Number: number; //This is not included in the serialised basket
}

export interface BasketCarRental {
  Message: string | undefined | null;
  Id: string | undefined | null;
  Name: string | undefined | null;
  PickupLocation: string | undefined | null;
  PickupDate: Date;
  DropoffLocation: string | undefined | null;
  DropoffDate: Date;
  Price: CarRentalPriceBreakdown | undefined | null;
  CurrencyCode: string | undefined | null;
  Extras: CarRentalExtra[] | undefined | null;
  Insurance: CarRentalInsurance | undefined | null;
  Fees: CarRentalFee[] | undefined | null;
}

export interface CarRentalPriceBreakdown {
  PayNow: CarRentalPayNowBreakdown | undefined | null;
  TotalPayNow: CarRentalPrice | undefined | null;
  TotalPayAtDesk: CarRentalPrice | undefined | null;
  Total: CarRentalPrice | undefined | null;
}

export interface CarRentalPayNowBreakdown {
  Rental: CarRentalPrice | undefined | null;
  Insurance: CarRentalPrice | undefined | null;
}

export interface CarRentalPrice {
  Amount: number;
  DailyAmount?: number;
  Label?: string | undefined | null;
  CurrencyCode?: string | undefined | null;
}

export interface CarRentalExtra {
  Name: string | undefined | null;
  Type: string | undefined | null;
  Quantity: number;
  Price: number;
  IncludedInRate: boolean;
}

export interface CarRentalInsurance {
  Name: string | undefined | null;
}

export interface CarRentalFee {
  Name: string | undefined | null;
  Price: number;
}

export interface TravelInsuranceBasket {
  AuthToken: string | undefined | null;
  TravelInsuranceLanguageCode: string | undefined | null;
  CostOfTrip: number;
  SeatTypeSelected: TravelInsuranceSelectedSeatOption;
  FlightAncillaries: FlightAncillary[] | undefined | null;
  InsuredPassengers: TravelInsuranceInsuredPassenger[] | undefined | null;
  Policy: TravelInsurancePolicy | undefined | null;
  QuoteOutboundRoute: TravelInsuranceQuoteRoute | undefined | null;
  QuoteReturnRoute: TravelInsuranceQuoteRoute | undefined | null;
}

export enum TravelInsuranceSelectedSeatOption {
  Unknown = 0,
  None = 1,
  Standard = 2,
  ExtraLegRoom = 3,
  FrontRow = 4
}

export interface FlightAncillary {
  Name: string;
  SelectedOption: TravelInsuranceAncillarySelectedOption;
}

export enum TravelInsuranceAncillarySelectedOption {
  Unknown = 0,
  No = 1,
  Yes = 2
}

export interface TravelInsuranceInsuredPassenger {
  InternalPassengerId: string;
  Type: TravelInsurancePassengerType;
}

export enum TravelInsurancePassengerType {
  Infant = 0,
  Child = 1,
  Adult = 2,
  Over64 = 3
}

export interface TravelInsurancePolicy {
  CalculationID: string;
  StartDate: Date;
  EndDate: Date;
  ProductName: string | undefined | null;
  ProductCode: string | undefined | null;
  FirstProductTermsLink: string | undefined | null;
  SecondProductTermsLink: string | undefined | null;
  TotalPrice: Price | undefined | null;
  AddOns: TravelInsuranceAddOn[] | undefined | null;
}

export interface TravelInsuranceAddOn {
  Name: string | undefined | null;
  Code: string | undefined | null;
  Price: Price | undefined | null;
}

export interface TravelInsuranceQuoteRoute {
  OriginIata: string | undefined | null;
  OriginCountryCode: string | undefined | null;
  DestinationIata: string | undefined | null;
  Date: string | undefined | null;
}

export interface FunnelFlightVoucherCharges {
  SegmentId: SegmentId | undefined | null;
  VoucherCostCharge: FunnelFlightVoucherCharge | undefined | null;
  VoucherRedeemableAmountCharge: FunnelFlightVoucherCharge | undefined | null;
}

type SegmentId = string;
//SegmentId is included in the serialised basket as a string with the date (in yyyyMMdd format), originIata and destinationIata, flightNumber properties concatanated together (i.e. 'date'+'originIata'+'destinationIata'+'flightNumber') without any additional properties
// export interface SegmentId {
//   Date: Date; //This is not included in the serialised basket
//   OriginIata: string | undefined | null; //This is not included in the serialised basket
//   DestinationIata: string | undefined | null; //This is not included in the serialised basket
//   FlightNumber: number; //This is not included in the serialised basket
// }

export interface FunnelFlightVoucherCharge {
  ChargeCode: ItemChargeCodes;
  Amount: number;
  AmountWithCreditCard: number;
}

export enum ItemChargeCodes {
  Infant = 0,
  HoldLuggage = 1,
  HoldLuggageExcessWeight = 2,
  SmallSportsEquipment = 3,
  LargeSportsEquipment = 4,
  Seat = 5,
  SmallHoldLuggage = 6,
  VoucherCost = 7,
  VoucherRedeemableAmount = 8,
  InFlightVoucherOnBoardPrice = 9
}

export interface Benefit {
  FlightInternalId: string;
  PassengerInternalId: string;
  Key: string | undefined | null;
  Quantity: number;
  IncludedInFare: boolean;
}

export interface Product {
  ProductInternalId: string;
  FlightInternalId?: string | undefined | null;
  PassengerInternalId: string;
  Price: number;
  ChargeCode: string | undefined | null;
  Benefits: ProductBenefit[] | undefined | null;
  Data: any | undefined | null;
}

export interface FunnelProduct extends Product {
  IncludedInFare?: boolean;
  Included?: boolean; // required for specific products like Seat (SSC2) and Standard hold bag (LUG) in Products array
}

export interface ProductBenefit {
  Key: string | undefined | null;
  Quantity: number;
}

export interface BasketFare {
  FlightInternalId: string;
  PassengerInternalId: string;
  Price: number;
  PriceWithoutFlightFare: number;
  AverageBundleDiscountPerPassenger?: number;
}

export interface BasketBase {
  Finalized: boolean;
  BookingReference: string | undefined | null;
  CurrencyCode: string | undefined | null;
  LanguageCode: string | undefined | null;
}

export interface FunnelBasket extends BasketBase {
  WebsiteRegionCode: string | undefined | null;
  MemberDetails: DomainMemberDetails | undefined | null;
  NewMemberPassword: string | undefined | null;
  Passengers: FunnelPassenger[] | undefined | null;
  Associations: FlightAssociation[] | undefined | null;
  CarriedInfants: CarriedInfant[] | undefined | null;
  JourneyPairs: JourneyPair[] | undefined | null;
  CarRental: BasketCarRental | undefined | null;
  TravelInsurance: TravelInsuranceBasket | undefined | null;
  ReasonForTravelCode: string | undefined | null;
  FareType: FareType;
  FareClass: string | undefined | null;
  FlightVoucherCharges: FunnelFlightVoucherCharges[] | undefined | null;
  Benefits: Benefit[] | undefined | null;
  Products: FunnelProduct[] | undefined | null;
  Fares: BasketFare[] | undefined | null;
  BundleCode: string | undefined | null;
  DiscountedBundle?: boolean;
}
